<div
  :class="{'d-flex justify-center margin-location-mobile' : mobile, 'd-flex justify-center' : !mobile}"
>
  <v-select
    :items="selectboxEntries"
    :model-value="selectedContactId"
    item-title="name"
    item-value="id"
    hide-details
    variant="solo"
    flat
    :max-width="mobile ? 186 : 350"
    @update:modelValue="selectboxEntryChanged"
  >
    <template v-slot:selection="{ item }">
      <tooltip-text
        v-if="item != undefined"
        :maxLength="24"
        :text="item.name"
        :class="{'location-entry-mobile text-mobile' : mobile, 'location-entry-desktop text-headline-small' : !mobile}"
        class="font-weight-medium text-center"
      >
      </tooltip-text>
    </template>
    <template v-slot:item="{ item, props }">
      <v-list-item v-if="item != undefined" v-bind="props">
        <template v-slot:title>
          <div
            :class="{'location-entry-mobile text-body-medium' : mobile, 'location-entry-desktop text-body-large' : !mobile}"
            class="pa-2 font-weight-regular"
          >
            {{ item.name }}
          </div>
        </template>
      </v-list-item>
    </template>
  </v-select>
</div>
